<template>
  <ModalOverlay
    :id="name"
    title="Details"
    width="44.25rem"
    :disable-teleport="true"
    @close="close"
  >
    <template #body>
      <div id="details-modal-content">
        <PriceOverlayMcom v-if="isMcom" />
        <PriceOverlayBcom v-else />
        <hr class="divider gray-background expanded margin-top-z margin-bottom-z">
        <template
          v-for="badgeValue in badgesList"
          :key="badgeValue.promoId"
        >
          <GiftBadgeDetails
            v-if="!!badgeValue?.giftProducts"
            :badge="badgeValue"
          />
          <RebateBadgeDetails
            v-else-if="isMcom && !badgeValue?.applicableToAllUpcs && !!badgeValue?.rebateInfo"
            :badge="badgeValue"
          />
          <BadgeDetails
            v-else
            :badge="badgeValue"
          />
        </template>
        <Accordion size="large">
          <AccordionTab
            header="Pricing Policy"
            :content-style="tabStyle"
            header-class="accordion-header-padding"
          >
            <p
              class="regular pricing-policy-body"
              data-el="product-dimensions"
            >
              Our Regular (REG) and Original (ORIG) prices are based on a number of factors that include cost, profit
              margin, expected demand, inventory levels, competition and promotional activity, such as sales and coupons.
              Regular and Original prices are our own offering prices. That means we offered the merchandise in our stores
              or on macys.com at those prices, though we may not have sold items at that price. So, the savings we show
              from these prices may not be based on actual sales of the items at the higher price. In addition, some
              Original prices may not have been in effect during the past 90 days, and intermediate markdowns may have
              been taken. Limited quantities, while supplies last.
              <br> <br> Placing items in your cart does not reserve them.
              If you leave an item in your cart, both pricing and availability are subject to change.
            </p>
          </AccordionTab>
        </Accordion>
        <hr class="divider gray-background expanded margin-top-z margin-bottom-z">

        <p
          class="regular margin-top-m"
          :content-style="tabStyle"
        >
          Savings Based On Offering Prices, Not Actual Sales
        </p>
      </div>
    </template>
  </ModalOverlay>
</template>

<script setup>
import { ModalOverlay } from '@atomic-ui/modalOverlay';
import { Accordion, AccordionTab } from '@atomic-ui/accordion';
import { brand } from 'config';
import BadgeDetails from './BadgeDetails';
import GiftBadgeDetails from './GiftBadgeDetails';
import RebateBadgeDetails from './RebateBadgeDetails';
import PriceOverlayMcom from './PriceOverlay';
import PriceOverlayBcom from './bcom/PriceOverlay.bcom';

defineProps({
  name: {
    type: String,
    required: true,
  },
  badgesList: {
    /** @type import('vue').PropType<BadgesList> */
    type: Array,
    required: true,
  },
});
const isMcom = brand === 'mcom';
const emit = defineEmits(['close']);

const tabStyle = { fontWeight: 400 };

const close = () => {
  emit('close');
};

</script>

<style lang="scss" scoped>
@import "~settingSCSS";
@import "~@core/csg/src/scss/typography/typography-mixins.scss";
@import "~@core/foundation/scss/foundation-6.7.4/scss/prototype/_spacing.scss";

:deep() {
  .regular {
    @include body(regular);
  }

  .divider {
    border: none;
    height: 1px;

    &.gray-background {
      background-color: $gray-3-color;
    }

    &.expanded {
      width: 100%;
    }
  }

  .view-more-button,
  .view-less-button {
    @include margin-direction('top', map-get($spacer, 's'));
  }

  @include breakpoint(medium up) {
    .view-more-button,
    .view-less-button {
      @include margin-direction('top', map-get($spacer, 'xs'));
    }
  }
}

.pricing-policy-body {
  @include padding-direction('bottom', map-get($spacer, 's'));
}

@include breakpoint(medium up) {
  .pricing-policy-body {
    @include padding-direction('bottom', 0);
  }
}
</style>
